module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/trips/trips-details/trips-details.component.css
// module id = ./src/app/trips/trips-details/trips-details.component.css
// module chunks = main